export const Color = {
	themeColor: "#ff561d",
	success: "rgba(8, 187, 144, 0.85)",
	danger: "#d01f07",
	blue: "#1468cc",
};
